const getPath = paths => paths.reduce((acc, path) => {
  const {
    latitude: lat,
    longitude: lng
  } = path;
  acc.push({
    lat,
    lng
  });
  return acc;
}, []);
export default getPath;
//# sourceMappingURL=get-path.js.map